module.exports = {"svg":{"$":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"},"title":["UI_AlignTop_16"],"path":[{"$":{"d":"M6,5v9H3V5H6M7,4H2V15H7V4Zm9-1V1H0V3Zm-2,9V4H9v8Z","fill":"#464646"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/UI_AlignTop_16.svg
// module id = d/3f
// module chunks = 1